import reducer from 'components/deploy/reducers';
import App from 'components/deploy/container';
import renderer from 'controllers/react_renderer';

window.app.pages.AgentsDeploy = function () {
  renderer.render(reducer, App, 'react-container', {
    agents: app.data.settings.agents,
    agent: app.data.settings.agent,
  });
};
